import React from "react";
import { Dashboard } from "../layout";
import { Header, NavMenu } from "../component/body";
import { Navigate, Route, Routes } from "react-router-dom";
import { logo } from "../assets";
import {
  Members,
  AddEditMember,
  Inquiries,
  AddEditInquiry,
  ViewInquiry,
  ViewMember,
  AddEditMM,
  Measurement,
  AddEditFreeze,
  FreezeMembers,
  AddEditPayment,
  Payments,
  Branches,
  AddEditBranch,
  DefBranch,
  AddEditUser,
  Users,
  Attendance,
  SubsPlans,
  SubsTypes,
  OrgForm,
  Invoices,
  AddEditInv,
  Cities,
  InqSrcs,
  MemberStatus,
} from "./";
import Home from "./Home/Home";
import FollowUpTypes from "./Inquiry/FollowUpType/FollowUpTypes";

const SiteRoute = () => {
  return (
    <Dashboard menu={<NavMenu />} header={<Header />} logo={logo}>
      <Routes>
        <Route path="/" element={<Navigate to="dashboard" />} />
        <Route path="/dashboard" element={<Home />} />

        <Route path="/inquiries" element={<Inquiries />} />
        <Route path="/view_inquiry/:id" element={<ViewInquiry />} />
        <Route path="/inquiry_form">
          <Route path=":id" element={<AddEditInquiry />} />
          <Route path="" element={<AddEditInquiry />} />
        </Route>

        <Route path="/members" element={<Members />} />
        <Route path="/view_member_profile/:id" element={<ViewMember />} />
        <Route path="/member_form">
          <Route path=":id" element={<AddEditMember />} />
          <Route
            path="conv_inq_to_member/:id"
            element={<AddEditMember convertInq={true} />}
          />
          <Route path="" element={<AddEditMember />} />
        </Route>

        <Route path="/freeze_members" element={<FreezeMembers />} />
        <Route path="/freeze_form">
          <Route path=":id" element={<AddEditFreeze />} />
          <Route path="" element={<AddEditFreeze />} />
        </Route>

        <Route path="/users" element={<Users />} />
        <Route path="/user_form">
          <Route path=":id" element={<AddEditUser />} />
          <Route path="" element={<AddEditUser />} />
        </Route>

        <Route path="/measurements" element={<Measurement />} />
        <Route path="/measurement_form">
          <Route path=":id" element={<AddEditMM />} />
          <Route path="" element={<AddEditMM />} />
        </Route>
        <Route
          path="/member_measurement_form/:id"
          element={<AddEditMM fromMember={true} />}
        />

        <Route path="/payments" element={<Payments />} />
        <Route path="/payment_form">
          <Route path=":id" element={<AddEditPayment />} />
          <Route path="" element={<AddEditPayment />} />
        </Route>

        <Route path="/invoices" element={<Invoices />} />
        <Route path="/invoice_form">
          <Route path=":id" element={<AddEditInv />} />
          <Route path="" element={<AddEditInv />} />
        </Route>

        <Route path="/attendance" element={<Attendance />} />
        <Route path="/cities" element={<Cities />} />

        <Route path="/branches" element={<Branches />} />
        <Route path="/default_branch" element={<DefBranch />} />
        <Route path="/branch_form">
          <Route path=":id" element={<AddEditBranch />} />
          <Route path="" element={<AddEditBranch />} />
        </Route>

        <Route path="/follow_up_types" element={<FollowUpTypes />} />
        <Route path="/inquiry_sources" element={<InqSrcs />} />
        <Route path="/subscription_types" element={<SubsTypes />} />
        <Route path="/subscription_plans" element={<SubsPlans />} />
        <Route path="/organization" element={<OrgForm />} />
        <Route path="/member_status" element={<MemberStatus />} />
      </Routes>
    </Dashboard>
  );
};

export default SiteRoute;
